import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, tap } from "rxjs";
import { environment } from "../../environments/environment";

@Injectable()
export class PublicApiInterceptor implements HttpInterceptor {
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    
    var playwrightToken = (window as any)?.__playwrightToken ?? null;
    var apiHeaderId = (window as any)?.__playwrightApiHeaderId ?? null;
    if (!!playwrightToken && !!apiHeaderId && !req.headers.has('X-Playwright-Token'))
    {
        //adding the playwright token to the headers 
        req = req.clone({
            setHeaders: {
                'X-Limelight-ClientId': apiHeaderId,
                'X-Playwright-Token': playwrightToken
            }
        });
    }
    else if (!req.headers.has('X-Limelight-ClientId'))
    {
        // Apply the headers
        req = req.clone({
        setHeaders: {
            'X-Limelight-ClientId': environment.apiHeaderId,
        }
        });

    }
    
    // Also handle errors globally
    return next.handle(req).pipe(
      tap(x => x, err => {
        // Handle this err
        console.error(`Error performing request, status code = ${err.status}`);
      })
    );
  }
}